import { useMemo } from "react";
import { mirrorPayloadExtensionFromPatientSummary } from "./mirrorStateExtensions";
import { useCreMirrorPatientSummary } from "./useCreMirrorPatientSummary";

/**
 * Composes every **static / study-driven** slice merged into `mirror-state` after `labels`.
 * Ephemeral UI (`useCreMirrorFeedback`) is merged in the parent (e.g. `PatientSidebar`).
 *
 * @see `hooks/cre/index.js` for the full extension contract checklist.
 */
export function useCreMirrorPayloadExtension() {
  const patientSummary = useCreMirrorPatientSummary();

  return useMemo(
    () => mirrorPayloadExtensionFromPatientSummary(patientSummary),
    [patientSummary],
  );
}
